"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateTeamMetadataResponseSchema = exports.GetTeamMetadataResponseSchema = exports.GetTeamMetadataBodySchema = exports.UpdateTeamMetadataBodySchema = exports.TeamMetadataSchema = void 0;
const core_1 = require("../../../core");
exports.TeamMetadataSchema = (0, core_1.JSONObject)({}, {
    title: "Metadata",
    description: "Additional metadata for team",
});
exports.UpdateTeamMetadataBodySchema = exports.TeamMetadataSchema;
exports.GetTeamMetadataBodySchema = exports.TeamMetadataSchema;
exports.GetTeamMetadataResponseSchema = exports.TeamMetadataSchema;
exports.UpdateTeamMetadataResponseSchema = exports.TeamMetadataSchema;
